import React from 'react';

import { DevicesViewColumns, DeviceType } from 'utils/constant';
import EditCollectionView from '../../common/EditCollectionView';
import DevicesView from '../DevicesView';

const SmartphonesPage = () => {
    return (
        <EditCollectionView 
            content={DevicesView}
            editPath="smartphone" 
            endpoint="devices" 
            type={DeviceType.SMARTPHONE}
            columns={[
                DevicesViewColumns.LABEL,
                DevicesViewColumns.TRACKER_IDENTIFIER,
                DevicesViewColumns.BRAND,
                DevicesViewColumns.MODEL,
                DevicesViewColumns.GROUP,
            ]}
        />
    );
}

export default SmartphonesPage;